/**
 * /enterprise — Enterprise sales contact (same idea as `app/packs.tsx`).
 * Public route; uses the shared contact form.
 */

import { EnterpriseContactScreen } from '../src/packs/components/EnterpriseContactScreen/EnterpriseContactScreen'

export default function EnterpriseRoute() {
  return <EnterpriseContactScreen />
}
